<template>
  <div>
    <div class="c-app">
      <Sidebar />
      <CWrapper>
        <Header />
        <div class="c-body">
          <main class="c-main">
            <CContainer fluid>
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </CContainer>
          </main>
        </div>
      </CWrapper>
    </div>
    <auto-logout class="invisible" @timeout="logoutUser()" />
  </div>
</template>

<script>
import Sidebar from './Sidebar';
import Header from './Header';
import AutoLogout from '../components/views/AutoLogout';

export default {
  name: 'MainLayout',
  components: {
    AutoLogout,
    Sidebar,
    Header,
  },
  methods: {
    logoutUser() {
      this.$store
        .dispatch('logout')
        .then(() => {
          this.$router.push('/login');
        })
        .catch((err) => {
          console.log(err);
          alert('Session timed out. Logging out.');
          this.$router.push('/login');
        });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
